/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import Chip from '@material-ui/core/Chip';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@mui/material/TableFooter';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import CreatePDF from './CreatePDF';
import ReactToPrint from 'react-to-print';
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';
import moment from 'moment';

var screenCode = 'CUSTOMEROUTLETWISEORDERHISTORYREPORT';

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton onClick={(e) => onPageChange(e, 0)} disabled={page === 0} aria-label="first page">
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton onClick={(e) => onPageChange(e, page - 1)} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton onClick={(e) => onPageChange(e, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton onClick={(e) => onPageChange(e, Math.max(0, Math.ceil(count / rowsPerPage) - 1))} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

export default function CustomerOutletWiseOrderHistoryReport() {
    const navigate = useNavigate();
    const componentRef = useRef();
    const boundLoginOutletRef = useRef(false);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const [group, setGroup] = useState([]);
    const [modeList, setModeList] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [outlets, setOutlets] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [reportData, setReportData] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        productCategoryID: '',
        productID: '',
        fromDate: '',
        toDate: '',
    });
    const [totalValues, setTotalValues] = useState({
        totalOrderedQuantity: 0,
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
        isOutletFilterEnabled: false,
    });

    const onKeyDown = (e) => e.preventDefault();

    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - reportData.length) : 0;

    const validationSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        customerTypeID: Yup.number()
            .typeError('Customer Type Required')
            .notOneOf([0], 'Customer Type Required')
            .required('Customer Type Required'),
        operationEntityID: Yup.array().min(1, 'Please select at least one Outlet').required('Outlet Required'),
        productCategoryID: Yup.array().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.array().min(1, 'Please Select Product').required('Product Required'),
        fromDate: Yup.date().required('Start Date required'),
        toDate: Yup.date().required('End Date required'),
    });

    const formik = useFormik({
        initialValues: {
            groupID: 0,
            modeOfOperationID: 1,
            customerTypeID: -1, 
            operationEntityID: [],
            productCategoryID: [],
            productID: [],
            fromDate: new Date().toISOString(),
            toDate: new Date().toISOString(),
        },
        validationSchema,
        onSubmit: () => trackPromise(SubmitForm()),
    });

    const { errors, touched, handleSubmit, getFieldProps, values, setValues } = formik;

    useEffect(() => {
        trackPromise(GetModes());
        trackPromise(GetTypes());
        getPermissions();
    }, []);

    async function getPermissions() {
        const permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find((p) => p.permissionCode === screenCode);
        if (!isAuthorized) navigate('/404');

        const isGroupFilterEnabled = permissions.find((p) => p.permissionCode === 'GROUPDROPDOWN');
        const isFactoryFilterEnabled = permissions.find((p) => p.permissionCode === 'FACTORYDROPDOWN');
        const isOutletFilterEnabled = permissions.find((p) => p.permissionCode === 'OUTLETDROPDOWN');

        setPermissions({
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
            isOutletFilterEnabled: isOutletFilterEnabled !== undefined,
        });

        const tokenData = TokenDecoder.getGroupFactoryToken();

        setValues((prev) => ({
            ...prev,
            groupID: parseInt(tokenData.group),
        }));

        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    async function bindLoginOutlet() {
        boundLoginOutletRef.current = true;

        const tokenData = TokenDecoder.getGroupFactoryToken();
        const loginOutletID = parseInt(tokenData.factory);
        if (Number.isNaN(loginOutletID)) return;

        for (const type of typeList) {
            const res = await services.GetOutletsByCustomerTypeID(formik.values.groupID, type.customerTypeID);
            const match = (res ?? []).some((o) => (o.outletID ?? o.factoryID) === loginOutletID);
            if (match) {
                formik.setFieldValue('customerTypeID', type.customerTypeID);
                return;
            }
        }
    }

    useEffect(() => {
        if (
            !boundLoginOutletRef.current &&
            !permissionList.isOutletFilterEnabled &&
            formik.values.groupID &&
            typeList.length > 0
        ) {
            bindLoginOutlet();
        }
    }, [typeList, permissionList.isOutletFilterEnabled, formik.values.groupID]);

    async function GetAllGroups() {
        const res = await services.GetAllGroups();
        if (res) setGroup(res);
    }

    async function GetModes() {
        const res = await services.getModeOfOperation();
        if (res) setModeList(res);
    }

    async function GetTypes() {
        const res = await services.getAvailableCustomerTypes();
        if (res) setTypeList(res);
    }

    useEffect(() => {
        if (
            formik.values.groupID &&
            formik.values.groupID !== 0 &&
            formik.values.customerTypeID !== 0 &&
            formik.values.customerTypeID !== '' &&
            (formik.values.customerTypeID !== -1 || typeList.length > 0)
        ) {
            trackPromise(GetOutlets());
        } else {
            setOutlets([]);
        }
        clearGridData();
        if (permissionList.isOutletFilterEnabled) {
            setSelectedOptions([]);
        }
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    }, [formik.values.groupID, formik.values.customerTypeID, typeList]);

    async function GetOutlets() {
        setOutlets([]);
        if (formik.values.customerTypeID === -1) {
            const allOutlets = [];
            for (const type of typeList) {
                const res = await services.GetOutletsByCustomerTypeID(
                    formik.values.groupID,
                    type.customerTypeID
                );
                if (res) {
                    const options = res.map((o) => ({ label: o.outletName ?? o.factoryName, value: o.outletID ?? o.factoryID }));
                    allOutlets.push(...options);
                }
            }
            const uniqueOutlets = Array.from(new Map(allOutlets.map((o) => [o.value, o])).values());
            setOutlets(uniqueOutlets);
        } else {
            const res = await services.GetOutletsByCustomerTypeID(
                formik.values.groupID,
                formik.values.customerTypeID
            );
            if (res) {
                const options = res.map((o) => ({ label: o.outletName ?? o.factoryName, value: o.outletID ?? o.factoryID }));
                setOutlets(options);
            }
        }
    }

    useEffect(() => {
        if (!permissionList.isOutletFilterEnabled && outlets.length > 0) {
            const tokenData = TokenDecoder.getGroupFactoryToken();
            const loginOutletID = parseInt(tokenData.factory);
            if (outlets.some((o) => o.value === loginOutletID)) {
                setSelectedOptions([loginOutletID]);
            }
        }
    }, [outlets, permissionList.isOutletFilterEnabled]);

    useEffect(() => {
        trackPromise(GetProductCategoties());
    }, []);

    useEffect(() => {
        clearGridData();
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
        setPage(0);
    }, [selectedOptions]);

    useEffect(() => {
        if (selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails());
        }
        clearGridData();
        setSelectedProductOptions([]);
        setPage(0);
    }, [selectedCategoryOptions]);

    useEffect(() => {
        clearGridData();
        setPage(0);
    }, [selectedProductOptions, fromDate, toDate]);

    async function GetProductCategoties() {
        const res = await services.GetProductCategoties();
        if (res) {
            setProductcatogery(res.map((c) => ({ label: c.productCategoryName, value: c.productCategoryID })));
        }
    }

    async function GetProductDetails() {
        const res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.join(','),
            selectedCategoryOptions.join(',')
        );
        if (res) {
            setProduct(res.map((p) => ({ label: p.productName, value: p.productID })));
        }
    }

    useEffect(() => {
        setValues((prev) => ({
            ...prev,
            operationEntityID: selectedOptions,
            productCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions,
        }));
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);

    useEffect(() => {
        if (reportData.length > 0) {
            const totalOrderedQuantity = reportData.reduce(
                (acc, row) => acc + (parseFloat(getFirstAvailableValue(row, ['orderedQuantity'], 0)) || 0),
                0
            );
            setTotalValues({ totalOrderedQuantity });
        } else {
            setTotalValues({ totalOrderedQuantity: 0 });
        }
    }, [reportData]);

    async function SubmitForm() {
        setReportData([]);
        const res = await services.GetCustomerOutletWiseOrderHistoryReportData(
            formik.values.groupID,
            formik.values.modeOfOperationID,
            formik.values.customerTypeID,
            selectedOptions,
            selectedCategoryOptions,
            selectedProductOptions,
            fromDate.toISOString(),
            toDate.toISOString()
        );
        setReportData(res ?? []);
        getSelectedDropdownValuesForReport();
    }

    function getSelectedDropdownValuesForReport() {
        const outletNames = selectedOptions
            .map((id) => outlets.find((o) => o.value === id)?.label ?? '')
            .filter(Boolean);

        const categoryNames = selectedCategoryOptions.map((id) => productcatogery.find((c) => c.value === id)?.label ?? '');
        const productNames = selectedProductOptions.map((id) => product.find((p) => p.value === id)?.label ?? '');
        const groupObj = group.find((g) => g.groupID === formik.values.groupID);

        setSelectedSearchValues({
            groupID: groupObj?.groupName ?? '',
            operationEntityID: outletNames.length > 0 ? outletNames.join(', ') : 'All Outlets',
            productCategoryID: categoryNames.join(', '),
            productID: productNames.join(', '),
            fromDate: moment(fromDate).format('YYYY/MM/DD'),
            toDate: moment(toDate).format('YYYY/MM/DD'),
        });
    }

    function clearGridData() {
        setPage(0);
        setReportData([]);
    }

    async function clearAll() {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
        setFromDate(new Date());
        setToDate(new Date());
        // customer type locked even after Clear is pressed.
        if (permissionList.isOutletFilterEnabled) {
            setSelectedOptions([]);
            formik.setFieldValue('customerTypeID', 0);
        }
        formik.setFieldValue('productCategoryID', '');
        formik.setFieldValue('productID', '');
        setReportData([]);
    }

    const handleGroupChange = (event) => {
        formik.handleChange(event);
    };

    const handleModeOfOperationChange = (event) => {
        formik.handleChange(event);
        clearGridData();
    };

    const handleCustomerTypeChange = (event) => {
        formik.handleChange(event);
        clearGridData();
    };

    const handleSelectChange = (event) => {
        const value = event.target.value;
        clearGridData();
        if (value.includes('')) {
            setSelectedOptions(selectedOptions.length === outlets.length ? [] : outlets.map((o) => o.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes('')) {
            setSelectedCategoryOptions(
                selectedCategoryOptions.length === productcatogery.length ? [] : productcatogery.map((o) => o.value)
            );
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes('')) {
            setSelectedProductOptions(selectedProductOptions.length === product.length ? [] : product.map((o) => o.value));
        } else {
            setSelectedProductOptions(value);
        }
    };

    function getFirstAvailableValue(row, keys, defaultValue = '') {
        if (!row) return defaultValue;
        for (const key of keys) {
            const value = row[key];
            if (value !== undefined && value !== null && value !== '') return value;
        }
        return defaultValue;
    }

    function formatQuantity(value) {
        const n = parseFloat(value);
        if (!Number.isFinite(n)) return '-';
        return n.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
    }

    function formatDate(value) {
        return value ? moment(value).format('YYYY/MM/DD') : '';
    }

    function formatUom(value) {
        const uomMap = { '1': 'Unit', '2': 'Kg', '3': 'g', '4': 'Batch' };
        return uomMap[String(value ?? '').trim()] || String(value ?? '');
    }

    function renderChips(selected, options) {
        if (selected.length === 0) return '';
        const first = options.find((o) => o.value === selected[0]);
        const chip = first ? <Chip label={first.label} /> : null;
        return selected.length === 1 ? chip : <div>{chip} + {selected.length - 1} more</div>;
    }

    async function createFile() {
        const rows = reportData;
        if (!rows.length) return;

        let totalOrderedQuantity = 0;
        const data = rows.map((row) => {
            const qty = parseFloat(getFirstAvailableValue(row, ['orderedQuantity'], 0)) || 0;
            totalOrderedQuantity += qty;
            return {
                Date: formatDate(getFirstAvailableValue(row, ['date'], null)),
                'Customer Code': getFirstAvailableValue(row, ['customerCode'], ''),
                'Customer Name': getFirstAvailableValue(row, ['customerName'], ''),
                'Outlet Code': getFirstAvailableValue(row, ['outletCode'], ''),
                'Location Code': getFirstAvailableValue(row, ['locationCode'], ''),
                'Outlet Name': getFirstAvailableValue(row, ['outletName'], ''),
                'SKU Code': getFirstAvailableValue(row, ['skuCode'], ''),
                'SKU Name': getFirstAvailableValue(row, ['skuName'], ''),
                UOM: formatUom(getFirstAvailableValue(row, ['uom'], '')),
                'Ordered Quantity': formatQuantity(qty),
            };
        });

        data.push({
            Date: '', 'Customer Code': '', 'Customer Name': '', 'Outlet Code': '',
            'Location Code': '', 'Outlet Name': '', 'SKU Code': '', 'SKU Name': '',
            UOM: 'Total Ordered Quantity',
            'Ordered Quantity': formatQuantity(totalOrderedQuantity),
        });

        const keys = Object.keys(data[0]);
        xlsx(
            [{ sheet: 'CustomerOutletWiseOrderHistory', columns: keys.map((k) => ({ label: k, value: k })), content: data }],
            { sheetName: 'Customer Outlet Wise Order History Report', fileName: 'Customer Outlet Wise Order History Report', writeOptions: {} }
        );
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Customer Outlet Wise Order History Report | FAPS">
                <Container>
                    <CommonPageHeader
                        path="/purchasingHistoryReport"
                        pageName="Customer Outlet Wise Order History Report"
                        leftButtonHidden
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>

                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        {...getFieldProps('groupID')}
                                        onChange={handleGroupChange}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{ readOnly: !permissionList.isGroupFilterEnabled }}
                                    >
                                        <MenuItem value={0}>Select Group *</MenuItem>
                                        {group.filter((g) => g.isActive).map((g) => (
                                            <MenuItem key={g.groupID} value={g.groupID}>{g.groupName}</MenuItem>
                                        ))}
                                    </TextField>

                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Mode of Operation"
                                        {...getFieldProps('modeOfOperationID')}
                                        onChange={handleModeOfOperationChange}
                                        InputProps={{ readOnly: true }}
                                    >
                                        <MenuItem value="">All Modes</MenuItem>
                                        {modeList.map((m) => (
                                            <MenuItem key={m.modeOfOperationID} value={m.modeOfOperationID}>{m.modeOfOperationName}</MenuItem>
                                        ))}
                                    </TextField>

                                    <TextField
                                        select
                                        fullWidth
                                        size="small" label="Customer Type *"
                                        {...getFieldProps('customerTypeID')}
                                        onChange={handleCustomerTypeChange}
                                        error={Boolean(touched.customerTypeID && errors.customerTypeID)}
                                        helperText={touched.customerTypeID && errors.customerTypeID}
                                        InputProps={{ readOnly: !permissionList.isOutletFilterEnabled }}
                                    >
                                        <MenuItem value={0} style={{ display: 'none' }}>Select Customer Types</MenuItem>
                                        <MenuItem value={-1}>All Types</MenuItem>
                                        {typeList.map((t) => (
                                            <MenuItem key={t.customerTypeID} value={t.customerTypeID}>{t.customerTypeName}</MenuItem>
                                        ))}
                                    </TextField>
                                </Stack>

                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel>Outlet *</InputLabel>
                                        <Select
                                            multiple size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Outlet *"
                                            readOnly={!permissionList.isOutletFilterEnabled}
                                            renderValue={(s) => renderChips(s, outlets)}
                                        >
                                            <MenuItem value="">
                                                <Checkbox checked={selectedOptions.length === outlets.length && outlets.length > 0} color="primary" />
                                                All Outlets
                                            </MenuItem>
                                            {outlets.map((o) => (
                                                <MenuItem key={o.value} value={o.value}>
                                                    <Checkbox checked={selectedOptions.includes(o.value)} color="primary" />
                                                    {o.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && permissionList.isOutletFilterEnabled && (
                                            <IconButton onClick={() => { setSelectedOptions([]); setSelectedCategoryOptions([]); setSelectedProductOptions([]); }}
                                                style={{ position: 'absolute', top: '50%', right: 24, transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.productCategoryID && errors.productCategoryID)}>
                                        <InputLabel>Product Category *</InputLabel>
                                        <Select
                                            multiple size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category *"
                                            disabled={selectedOptions.length === 0}
                                            renderValue={(s) => renderChips(s, productcatogery)}
                                        >
                                            <MenuItem value="">
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length && productcatogery.length > 0} color="primary" />
                                                All Product Categories
                                            </MenuItem>
                                            {productcatogery.map((c) => (
                                                <MenuItem key={c.value} value={c.value}>
                                                    <Checkbox checked={selectedCategoryOptions.includes(c.value)} color="primary" />
                                                    {c.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productCategoryID && errors.productCategoryID && (
                                            <FormHelperText>{errors.productCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={() => { setSelectedCategoryOptions([]); setSelectedProductOptions([]); }}
                                                style={{ position: 'absolute', top: '50%', right: 24, transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>

                                    <FormControl fullWidth error={Boolean(touched.productID && errors.productID)}>
                                        <InputLabel>Product *</InputLabel>
                                        <Select
                                            multiple size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product *"
                                            disabled={selectedCategoryOptions.length === 0}
                                            renderValue={(s) => renderChips(s, product)}
                                        >
                                            <MenuItem value="">
                                                <Checkbox checked={selectedProductOptions.length === product.length && product.length > 0} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((p) => (
                                                <MenuItem key={p.value} value={p.value}>
                                                    <Checkbox checked={selectedProductOptions.includes(p.value)} color="primary" />
                                                    {p.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productID && errors.productID && (
                                            <FormHelperText>{errors.productID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={() => setSelectedProductOptions([])}
                                                style={{ position: 'absolute', top: '50%', right: 24, transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>

                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4}>
                                    <Box sx={{ flex: 1 }}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="From Date *" value={fromDate}
                                                onChange={(v) => setFromDate(v)}
                                                maxDate={new Date()}
                                                renderInput={(params) => (
                                                    <TextField fullWidth size="small" onKeyDown={onKeyDown}
                                                        {...getFieldProps('fromDate')}
                                                        error={Boolean(touched.fromDate && errors.fromDate)}
                                                        helperText={touched.fromDate && errors.fromDate}
                                                        InputLabelProps={{ shrink: true }}
                                                        {...params} />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                label="To Date *" value={toDate}
                                                onChange={(v) => setToDate(v)}
                                                maxDate={new Date()}
                                                renderInput={(params) => (
                                                    <TextField fullWidth size="small" onKeyDown={onKeyDown}
                                                        {...getFieldProps('toDate')}
                                                        error={Boolean(touched.toDate && errors.toDate)}
                                                        helperText={touched.toDate && errors.toDate}
                                                        InputLabelProps={{ shrink: true }}
                                                        {...params} />
                                                )}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <Box sx={{ flex: 1 }} />
                                </Stack>

                                <Stack direction="row" justifyContent="flex-end" spacing={2}>
                                    <Button type="button" variant="outlined" color="error" onClick={clearAll}>Clear</Button>
                                    <Button type="submit" variant="outlined" color="secondary">Search</Button>
                                </Stack>
                            </Stack>

                            <br />

                            {reportData.length > 0 ? (
                                <Stack direction={{ xs: 'column', sm: 'row' }}>
                                    <Card style={{ width: '100%', overflowX: 'auto' }}>
                                        <TableContainer component={Paper} style={{ padding: 3.5, overflowX: 'auto' }}>
                                            <Table style={{ borderCollapse: 'collapse', border: '1px solid black', minWidth: 1200 }}>
                                                <TableHead>
                                                    <TableRow>
                                                        {['Date', 'Customer Code', 'Customer Name', 'Outlet Code', 'Location Code', 'Outlet Name', 'SKU Code', 'SKU Name', 'UOM', 'Ordered Quantity'].map((h, i) => (
                                                            <TableCell key={h} sx={{ fontWeight: 'bold', border: '1px solid black' }} align={i >= 6 ? 'right' : 'left'}>
                                                                {h}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage === -1 ? reportData : reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)).map((row, idx) => (
                                                        <TableRow key={idx}>
                                                            <TableCell sx={{ border: '1px solid black' }} align="left">{formatDate(getFirstAvailableValue(row, ['date'], null))}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="left">{getFirstAvailableValue(row, ['customerCode'], '')}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="left">{getFirstAvailableValue(row, ['customerName'], '')}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="left">{getFirstAvailableValue(row, ['outletCode'], '')}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="left">{getFirstAvailableValue(row, ['locationCode'], '')}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="left">{getFirstAvailableValue(row, ['outletName'], '')}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="right">{getFirstAvailableValue(row, ['skuCode'], '')}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="right">{getFirstAvailableValue(row, ['skuName'], '')}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="right">{formatUom(getFirstAvailableValue(row, ['uom'], ''))}</TableCell>
                                                            <TableCell sx={{ border: '1px solid black' }} align="right">{formatQuantity(getFirstAvailableValue(row, ['orderedQuantity'], ''))}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 'bold', border: '1px solid black' }} align="right" colSpan={9}>
                                                            Total Ordered Quantity
                                                        </TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', border: '1px solid black' }} align="right">
                                                            {formatQuantity(totalValues.totalOrderedQuantity)}
                                                        </TableCell>
                                                    </TableRow>
                                                    {emptyRows > 0 && (
                                                        <TableRow style={{ height: 53 * emptyRows }}>
                                                            <TableCell colSpan={10} />
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                                <TableFooter>
                                                    <TableRow>
                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                                            colSpan={10}
                                                            count={reportData.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            SelectProps={{ inputProps: { 'aria-label': 'rows per page' }, native: true }}
                                                            onPageChange={(e, p) => setPage(p)}
                                                            onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
                                                            ActionsComponent={TablePaginationActions}
                                                        />
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </TableContainer>
                                    </Card>
                                </Stack>
                            ) : (
                                <SearchNotFound searchQuery="Customer Outlet Wise Order History Report" />
                            )}
                        </Form>
                    </FormikProvider>

                    {reportData.length > 0 && (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button color="primary" variant="contained" style={{ marginRight: '1rem' }} onClick={createFile}>
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle="Customer Outlet Wise Order History Report"
                                trigger={() => (
                                    <Button color="primary" variant="contained" style={{ backgroundColor: 'red' }}>
                                        PDF
                                    </Button>
                                )}
                                content={() => componentRef.current}
                            />
                            <div style={{ position: 'absolute', left: -10000, top: 0 }}>
                                <CreatePDF
                                    ref={componentRef}
                                    reportData={reportData}
                                    searchData={selectedSearchValues}
                                    totalRowValue={totalValues}
                                />
                            </div>
                        </Box>
                    )}
                </Container>
            </Page>
        </>
    );
}
